import { BOT_ROLE } from "../constants";
import { Message } from "../types/ChatInterfaces";

export function removeMessageById(
  messages: Message[],
  messageIdToRemove: string | string[]
): Message[] {
  if (Array.isArray(messageIdToRemove)) {
    // If messageIdToRemove is an array, filter out any messages with an id in the array
    return messages.filter(
      (message) => !messageIdToRemove.includes(message.id)
    );
  } else {
    // If messageIdToRemove is a single string, filter out the message with that id
    return messages.filter((message) => message.id !== messageIdToRemove);
  }
}

export const getIdForMessageType = (
  messages: any[],
  type = "options"
): string => {
  const message = messages?.find((msg: { type: string }) => msg.type === type);
  return message?.id || "";
};

export const getLastSystemMsgId = (messages: Message[] = []) => {
  for (let i = messages.length - 1; i >= 0; i--) {
    const msg = messages?.[i];
    if (msg?.role === BOT_ROLE) {
      return msg?.id || "";
    }
  }
  return "";
};
export function getLastTwoIds(messages: Message[]) {
  // Filter out messages that do not have an 'id' property

  const messagesWithId = messages.filter((msg) => msg.id !== undefined);

  // Get the number of messages with an 'id' property
  const count = messagesWithId.length;

  if (count === 0) {
    // If no messages have an 'id', return an empty array
    return [];
  } else if (count === 1) {
    // If only one message has an 'id', return an array with that single id
    return [messagesWithId[0].id];
  } else {
    // If two or more messages have an 'id', return the last two ids
    return [messagesWithId[count - 2].id, messagesWithId[count - 1].id];
  }
}
